<template>
    <div class="badges">
        <template v-if="badges && badges.length > 0">
             <span class="badge"
                   v-for="(badge, index) in badges"
                   :key="index"
                   :style="{ color: badge.text_color, backgroundColor: badge.color }"
             >
                {{ badge.name }}
            </span>
        </template>
        <template v-if="hasDiscount && badgeDiscount && discountPrice < defaultPrice">
            <span class="badge"
                  :style="{ color: badgeDiscount.text_color, backgroundColor: badgeDiscount.color }"
            >
                {{ badgeDiscount.name }}
            </span>
        </template>
        <template v-if="lowStock && badgeOutOfStock">
            <span class="badge"
                  :style="{ color: badgeOutOfStock.text_color, backgroundColor: badgeOutOfStock.color }"
            >
                {{ badgeOutOfStock.name }}
            </span>
        </template>
    </div>
</template>

<script>
import {inject, onMounted, reactive, toRefs} from 'vue'

import AddToWishlist from '../../buttons/AddToWishlist'
import AddToCart from '../../buttons/AddToCart'
import RemoveFromWishlist from '../../buttons/RemoveFromWishlist'

export default {

    props: [
        'badges',
        'discount_price',
        'main_price',
        'default_price',
        'stock',
        'has_variations',
        'variation_values',
        'set_products',
    ],

    components: {
        AddToWishlist,
        AddToCart,
        RemoveFromWishlist
    },

    setup(props) {

        const state = reactive({
            hasDiscount: props.discount_price > 0,
            mainPrice: props.main_price,
            defaultPrice: props.default_price,
            discountPrice: props.discount_price,
            badgeDiscount: null,
            badgeOutOfStock: null,
            lowStock: props.stock <= 2,
        })

        const constants  = inject('constants')

        onMounted( () => {
            state.badgeDiscount = JSON.parse(constants.badgeDiscount)
            state.badgeOutOfStock = JSON.parse(constants.badgeOutOfStock)

            if ( props.has_variations && props.variation_values )
                handleVariationDiscount()
        })

        function handleVariationDiscount() {

            props.variation_values.forEach( value => {
                if ( value.stock <= 2 )
                    state.lowStock = true

                if ( value.discount_price ) {
                    state.hasDiscount = true
                }
            })
        }

        return {
            ...toRefs(constants),
            ...toRefs(state)
        }
    }
}
</script>
